<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      v-model="visible"
      :close-on-click-modal="false"
      width="760px"
      :visible.sync="visible"
       :before-close="handleClose"
    >
      <el-form :model="viewForm" class="toolbar" ref="viewForm" label-width="80px">
       <el-row type="flex" justify="center" >
          <el-col :span="8">
            <el-form-item label="选品单号">
              <el-input v-model="viewForm.sipCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16" style="display:flex">
            <el-form-item label="选品模式">
              <el-select v-model="viewForm.sipMode" placeholder="请选择" disabled>
                <el-option label="季节性选品" value="1"></el-option>
                <el-option label="非季节性选品" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sipIndication">
                <el-select v-model="viewForm.sipIndication" placeholder="请选择" disabled>
                <el-option label="上半年" value="1"></el-option>
                <el-option label="下半年" value="2"></el-option>
                <el-option label="夏季" value="3"></el-option>
                <el-option label="冬季" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="8">
            <el-form-item label="商品大类">
              <el-input v-model="viewForm.sipItemDept" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <!-- <el-form-item label="棚格图分类">
              <el-input v-model="viewForm.sipSpaceCode" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="棚格图分类" prop="sipSpaceCode">
              <el-select
                v-model="viewForm.sipSpaceCode"
                filterable
                placeholder="请选择"
                @change="showListByWijVersion"
              >
                <el-option
                  v-for="(item,i) in List"
                  :key="i"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" style="margin-bottom:10px;">
          <el-col :span="8">
            <el-form-item label="版本">
              <el-select v-model="viewForm.version" filterable placeholder="请选择" class="versionSelect" disabled>
                <el-option
                  v-for="(item,i) in versionList"
                  :key="i"
                  :label="'V' + item"
                  :value="item + ''"
                  @change="showListByWijVersion"
                >                 
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16" style="display:flex">
            <el-form-item label="选版">
              <el-select v-model="viewForm.sipSpaceMode" placeholder="请选择" disabled>
                <el-option label="T版" value="1"></el-option>
                <el-option label="S版" value="2"></el-option>
                <el-option label="M版" value="3"></el-option>
                <el-option label="L版" value="4"></el-option>
                <el-option label="XL版" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sipUpperId">
              <el-input v-model="viewForm.sipUpperId" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
      <div v-if="lookOrUpdate=='look'" style="padding-bottom:10px;">
        <h3 style="text-align:right;">版本：{{wijIwfversion}}</h3>
      </div>
      <!-- 列表 -->
      <el-table
        :data="ruleItemList"
        class="listTowline"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%;"
      >
        <el-table-column prop="sitOrder" label="优先级" min-width="80"></el-table-column>
        <el-table-column prop="sirRuleName" label="规则名称" min-width="80"></el-table-column>
        <el-table-column label="详情" min-width="80">
          <template slot-scope="scope">
            <el-button style="padding:5px;" @click.stop="handleLook(scope.row)" v-if="!(scope.row.sitRuleCode=='5' || scope.row.sitRuleCode=='6')">查看</el-button>
            <el-button type="primary" style="padding:5px;" @click.stop="handleModify(scope.row)" v-if="(lookOrUpdate=='update') && (scope.row.sitRuleCode=='2' || scope.row.sitRuleCode=='7')">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dalog-footer">
        <el-button type="primary" @click.native="updateRulealterAppStatus()" :loading="submitLoading" v-if="lookOrUpdate=='update'">提交</el-button>
        <el-button @click.native="handleClose()">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 查看货架sku选品数量 -->
    <SkuDetail  v-if="skuVisible" :visible.sync="skuVisible" :dept="viewForm.sipItemDept" :spaceclassNew="viewForm.sipSpaceCode" :params="params" :pogList="List"></SkuDetail>
    <!-- 查看细分类必选 -->
    <SsubDetail  v-if="ssubVisible" :visible.sync="ssubVisible" :params="params" :pogList="List"></SsubDetail>
    <!-- 查看淘汰单品不选 -->
    <WeedOutDetail  v-if="weedOutVisible" :visible.sync="weedOutVisible" :params="params" :pogList="List"></WeedOutDetail>
    <!-- 查看免死单品必选 -->
    <EssentialDetail  v-if="essentialVisible" :visible.sync="essentialVisible" :params="params" :pogList="List"></EssentialDetail>
    <!-- 查看权重 -->
    <WeightSetCheckDetail  v-if="weightSetCheckVisible" :visible.sync="weightSetCheckVisible" :viewFormDetail="weightForm" :pogList="List"></WeightSetCheckDetail>
    <!-- 修改细分类必选 -->
    <SsubUpdate  v-if="ssubUpdateVisible" :visible.sync="ssubUpdateVisible" :params="params" :pogList="List"></SsubUpdate>
    <!-- 修改权重 -->
    <WeightSetUpdate  v-if="weightSetUpdateVisible" :visible.sync="weightSetUpdateVisible" :viewFormDetail="weightChangeForm" :pogList="List"></WeightSetUpdate>
  </div>
</template>
<script>
import SkuDetail from "./look/skuDetail";
import SsubDetail from "./look/ssubDetail";
import WeedOutDetail from "./look/weedOutDetail";
import EssentialDetail from "./look/essentialDetail";
import WeightSetCheckDetail from "./look/weightSetCheckDetail";
import SsubUpdate from "./update/ssubUpdate";
import WeightSetUpdate from "./update/weightSetUpdate";
export default{
 props: {
    viewForm: {
      type: Object,
      default() {
          return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    sipId : {
      type : String
    },
    lookOrUpdate: {
      type : String
    },
    dialogTitle: {
      type : String
    }
  },
  data: function() {
    return {
      submitLoading: false,
      listLoading : false,
      ruleItemList : [],
      versionList : [],
      list: [],
      ruleViewForm: {},
      weightForm: {},
      weightChangeForm: {},
      mrId: "",
      versionDisable: false,
      skuVisible : false,
      ssubVisible : false,
      weedOutVisible : false,
      essentialVisible : false,
      weightSetCheckVisible : false,
      ssubUpdateVisible : false,
      weightSetUpdateVisible : false,
      params : {},
      wijIwfversion: ''  //查看选品规则 展示权重版本
    };
  },
  components : {
    SkuDetail,
    SsubDetail,
    WeedOutDetail,
    EssentialDetail,
    WeightSetCheckDetail,
    SsubUpdate,
    WeightSetUpdate
  },
  created(){
    this.List = this.viewForm.sipSpaceCode.split(",");
    this.viewForm.sipSpaceCode = this.List[0];
    console.log(this.List);
    if(this.lookOrUpdate=='update'){
      this.versionDisable = true;
      this.getMrId();
    }
  },
  methods : {
    getRuleForm(){
      for(let key in this.viewForm){
        this.ruleViewForm[key] = this.viewForm[key];
      }
    },
    //获取版本号
    showListByWijVersion(ssub) {
      var _this = this;
      let para = {};
      if (!(ssub == null || ssub == undefined || ssub == "")) {
        para = { 
          wijPogcode: ssub,
          sipId: _this.viewForm.sipId,
          wijVersion: _this.viewForm.version
        };
      }
      this.listLoading = true;
      this.$api.selectgoods.showListByWijVersion(para).then(res => {
        this.wijIwfversion = res.data.result[0].wijIwfversion;
        this.listLoading = false;
      });
    },
    handleClose(){
      this.$emit('update:visible', false);
    },
    getMrId() {
      var _this = this;
      let para = {"sipId":this.viewForm.sipId};
      _this.$api.selectgoods.getRulealterAppBysipId(para).then(res => {
        _this.mrId = res.data.object.mrId;
      });
    },
    updateRulealterAppStatus() {
      var _this = this;
      _this.submitLoading = true;
      let para = {
        mrId: _this.mrId,
        mrStatus: 2
      };
      _this.$api.selectgoods.updateRulealterAppStatus(para).then(res => {
        if (res.data.code == "0000") {
          _this.$message({
            message: "提交成功",
            type: "success"
          });
        } else {
          _this.$message({
            message: "提交失败",
            type: "error"
          });
        }
        _this.submitLoading = false;
        _this.handleClose();
      });
    },
    getRuleItemList() {
      var _this = this;
      let para = {};
      this.listLoading = true;
      this.$api.selectgoods.getRuleItemListDetail(para).then(res => {
        this.ruleItemList = res.data.result;
        this.listLoading = false;
      });
    },
    getVersionList(){
      var _this = this;
      let para = { "sipId" : _this.sipId};
      this.listLoading = true;
      this.$api.selectgoods.getWijVersionListBySipId(para).then(res => {
        this.versionList = res.data.result;
        this.$set(this.viewForm,'version',res.data.result[0]);
        // this.viewForm.version =  res.data.result[0];
        this.showListByWijVersion(this.viewForm.sipSpaceCode);
        this.listLoading = false;
      });
    },
    handleLook(row){
      switch(row.sitRuleCode){
        case "1" : this.skuClick();         //货架sku选品数量
                break;
        case "2" : this.ssubClick();         //细分类必选
                break;
        case "3" : this.weedOutClick();         //淘汰单品不选
                break;
        case "4" : this.essentialClick();         //免死单品必选
                break;
        case "7" : this.weightSetCheckClick();         //按权重得分从高到低
                break;
        default :
                break;
      }
    },
    skuClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.viewForm.sipSpaceCode;
      this.params.mrId = this.mrId;
      this.params.sipId = this.sipId;
      this.params.isvVersion = this.viewForm.version;
      this.skuVisible = true;
    },
    ssubClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.viewForm.sipSpaceCode;
      this.params.mrId = this.mrId;
      this.params.sipId = this.sipId;
      this.ssubVisible = true;
    },
    weedOutClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.viewForm.sipSpaceCode;
      this.params.sipId = this.sipId;
      this.weedOutVisible = true;
    },
    essentialClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.viewForm.sipSpaceCode;
      this.params.sipId = this.sipId;
      this.essentialVisible = true;
    },
    weightSetCheckClick(){
      // this.listLoading = true;
      this.weightForm.dept = this.viewForm.sipItemDept;
      this.weightForm.spaceclassNew = this.viewForm.sipSpaceCode;
      this.weightForm.sipMode = this.viewForm.sipMode;
      this.weightForm.sipIndication = this.viewForm.sipIndication;
      this.weightForm.mrId = this.mrId;
      this.weightForm.sipId = this.viewForm.sipId;
      this.weightForm.wijVersion = this.viewForm.version;
      this.weightSetCheckVisible = true;      
    },
    handleModify(row){
      switch(row.sitRuleCode){
        case "2" : this.subclassifyRequired();         //细分类必选
                break;
        case "7" : this.getWeightSetChange();         //按权重得分从高到低
                break;
        default :
                break;
      }
    },
    subclassifyRequired(){
      this.params.mrId = this.mrId;
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.viewForm.sipSpaceCode;
      this.ssubUpdateVisible = true;
    },
    getWeightSetChange() {
      this.weightChangeForm.mrId = this.mrId;
      this.weightChangeForm.dept = this.viewForm.sipItemDept;
      this.weightChangeForm.spaceclassNew = this.viewForm.sipSpaceCode;
      this.weightChangeForm.mrdMode = this.viewForm.sipMode;
      this.weightChangeForm.mrdIndication = this.viewForm.sipIndication;
      this.weightSetUpdateVisible = true;
      // var _this = this;
      // let para = {"sipId":this.viewForm.sipId};
      // this.listLoading = true;
      // this.$api.selectgoods.getRulealterAppBysipId(para).then(res => {
      //   this.listLoading = false;
        // this.$router.push({
        //   path: "/selectionmanagement/rules/weightSetChange",
        //   query: {
        //     mrId : res.data.object.mrId,
        //     dept:_this.viewForm.sipItemDept,
        //     spaceclassNew:_this.viewForm.sipSpaceCode,
        //     mrdMode : _this.viewForm.sipMode,
        //     mrdIndication : _this.viewForm.sipIndication
        //   }
        // });
      // });
    },
  },
  mounted(){ 
    this.getRuleItemList();
    this.getVersionList();
  }
} 
</script>
<style>
  .sipUpperId .el-form-item__content,.sipIndication .el-form-item__content,.clearItem .el-form-item__content{
    margin-left:5px!important;
  }
  .versionSelect input{
    border:1px solid #409EFF;
  }
</style>


// WEBPACK FOOTER //
// src/views/selectgoods/selectionmanagement/listquery/ruleDialog.vue